import React, { useState } from "react";
import {
  FaFilePdf,
  FaDownload,
  FaExternalLinkAlt,
  FaTimes,
} from "react-icons/fa";
import "./DirectorSection.css";
import directorFoto from "../assets/images/about.jpg";

// Importación PDFs
import pdfBachiller from "../assets/docs/bachiller.pdf";
import pdfLicenciado from "../assets/docs/licenciado.pdf";
import pdfMaestria from "../assets/docs/grado_mg.pdf";
import pdfDoctor from "../assets/docs/grado_dr.pdf";

const documentos = [
  { titulo: "Bachiller", pdf: pdfBachiller },
  { titulo: "Licenciado", pdf: pdfLicenciado },
  { titulo: "Maestría", pdf: pdfMaestria },
  { titulo: "Doctor", pdf: pdfDoctor },
  {
    titulo: "Artículos de Investigación",
    link: "https://journals.continental.edu.pe/index.php/apuntes/article/view/882/804",
  },
  {
    titulo: "Artículos de Investigación",
    link: "https://journals.continental.edu.pe/index.php/apuntes/article/view/895/815",
  },
  {
    titulo: "Artículos de Investigación",
    link: "https://journals.continental.edu.pe/index.php/apuntes/issue/view/73",
  },
];

const DirectorSection = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  const handleOpenPdf = (pdf) => {
    setSelectedPdf(pdf);
  };

  const handleClosePdf = () => {
    setSelectedPdf(null);
  };

  return (
    <section className="director-modern py-5">
      <div className="container text-center">     
        <div className="director-profile mb-5">
          <img src={directorFoto} alt="Director" className="director-img shadow-lg" />
          <h2 className="fw-bold text-uppercase mt-4 text-primary">
            Dr. Ledgar Nicolao Sovero Sovero
          </h2>
          <p className="text-muted fs-5">Director General</p>
        </div>

        {/* Documentos */}
        <div className="row g-4 justify-content-center">
          {documentos.map((doc, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <div className="pdf-card shadow-sm rounded-4 bg-white p-4 text-center">
                <div className="doc-icon mb-3">
                  {doc.pdf ? (
                    <FaFilePdf size={80} color="#c62828" />
                  ) : (
                    <FaExternalLinkAlt size={70} color="#007bff" />
                  )}
                </div>

                <h5 className="fw-bold mb-3">{doc.titulo}</h5>

                <div className="d-flex justify-content-center gap-2 flex-wrap">
                  {doc.pdf ? (
                    <>
                      <button
                        onClick={() => handleOpenPdf(doc.pdf)}
                        className="btn btn-doc"
                      >
                        <FaFilePdf className="me-2" /> Ver Documento
                      </button>
                      <a
                        href={doc.pdf}
                        download
                        className="btn btn-secondary"
                      >
                        <FaDownload className="me-2" /> Descargar
                      </a>
                    </>
                  ) : (
                    <a
                      href={doc.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-doc"
                    >
                      <FaExternalLinkAlt className="me-2" /> Ir al Sitio
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/*Modal PDF */}
      {selectedPdf && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClosePdf}>
              <FaTimes size={20} />
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="Vista PDF"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default DirectorSection;
